function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M18.8 10.16a1.01 1.01 0 011.9 0l1.04 2.81a8.1 8.1 0 004.79 4.79l2.8 1.04c.9.33.9 1.57 0 1.9l-2.8 1.04a8.1 8.1 0 00-4.79 4.79l-1.04 2.8c-.33.9-1.57.9-1.9 0l-1.04-2.8a8.1 8.1 0 00-4.79-4.79l-2.8-1.04a1.01 1.01 0 010-1.9l2.8-1.04a8.1 8.1 0 004.79-4.79l1.04-2.8z",
  fill: "url(#paint0_linear_94_995)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.8 2.53a.81.81 0 011.53 0l.5 1.37a4.05 4.05 0 002.4 2.4l1.37.5c.7.27.7 1.27 0 1.53l-1.37.5a4.05 4.05 0 00-2.4 2.4l-.5 1.37a.81.81 0 01-1.52 0l-.51-1.37a4.05 4.05 0 00-2.4-2.4l-1.37-.5a.81.81 0 010-1.52L3.9 6.3a4.05 4.05 0 002.4-2.4l.5-1.37z",
  fill: "url(#paint1_linear_94_995)"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_94_995",
  x1: "2",
  y1: "2",
  x2: "26",
  y2: "27.5",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F84CC8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#EF8200"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_94_995",
  x1: "2",
  y1: "2",
  x2: "26",
  y2: "27.5",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F84CC8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#EF8200"
}))));